export const PROGRESS_FILTER = {
  ALL: 'all',
  FUTURE: 'future',
  ONGOING: 'ongoing',
  PAST: 'past',
  CANCELED: 'cancelled'
}

export const ORDERED_REQUIRED_ACTIONS = ['DOCUMENT_UPLOAD']
